
export const ACTIVE_INACTIVE_DROPDOWN = [
    { label: 'Active', value: "active" },
    { label: 'In-active', value: "inactive" },
    { label: 'Deleted', value: "deleted" }
]